import KumovegaError from "./KumovegaError";
import { ImportResponse } from "../Documents";

export default class ImportError extends KumovegaError {
  importResults: ImportResponse[];
  constructor(message: string, importResults: ImportResponse[]) {
    super(message);
    this.importResults = importResults;
  }
}
